export class InvitationType {

    // private to disallow creating other instances of this type
    private constructor(private readonly key: string, public readonly value: any, public readonly icon: string) {
    }

    getKey() {
        return this.key;
    }

    getIcon() {
        return this.icon;
    }

    getValue() {
        return this.value;
    }

    static retrieveValueByKey(key: string): string {
        switch (key) {
            case this.FAMILLE.getKey():
                return this.FAMILLE.getValue();
            case this.AMIS.getKey():
                return this.AMIS.getValue();
            case this.AMIS_PARENTS.getKey():
                return this.AMIS_PARENTS.getValue();
            case this.VH_PARENTS.getKey():
                return this.VH_PARENTS.getValue();
            case this.VH.getKey():
                return this.VH.getValue();
            default:
                return this.EMPTY.getValue();
        }
    }

    static retrieveKeyByValue(value: string): string {
        switch (value) {
            case this.FAMILLE.getValue():
                return this.FAMILLE.getKey();
            case this.AMIS.getValue():
                return this.AMIS.getKey();
            case this.AMIS_PARENTS.getValue():
                return this.AMIS_PARENTS.getKey();
            case this.VH_PARENTS.getValue():
                return this.VH_PARENTS.getKey();
            case this.VH.getValue():
                return this.VH.getKey();
            default:
                return this.EMPTY.getKey();
        }
    }

    static retrieveIconByValue(value: string): string {
        switch (value) {
            case this.FAMILLE.getValue():
                return this.FAMILLE.getIcon();
            case this.AMIS.getValue():
                return this.AMIS.getIcon();
            case this.AMIS_PARENTS.getValue():
                return this.AMIS_PARENTS.getIcon();
            case this.VH_PARENTS.getValue():
                return this.VH_PARENTS.getIcon();
            case this.VH.getValue():
                return this.VH.getIcon();
            default:
                return this.EMPTY.getIcon();
        }
    }

    static readonly FAMILLE = new InvitationType('FAMILLE', 'Repas + Vin d\'honneur (Famille)', 'bi-person-hearts');
    static readonly AMIS = new InvitationType('AMIS', 'Repas + Vin d\'honneur (Amis)', 'bi-people-fill');
    static readonly AMIS_PARENTS = new InvitationType('AMIS_PARENTS', 'Repas + Vin d\'honneur (Parents)', 'bi-people-fill');
    static readonly VH_PARENTS = new InvitationType('VH_PARENTS', 'Vin d\'honneur uniquement (Parents)', 'bi-cup-straw');
    static readonly VH = new InvitationType('VH', 'Vin d\'honneur uniquement', 'bi-cup-straw');
    static readonly EMPTY = new InvitationType('', '-----', '');
}
